module.exports = __webpack_public_path__ + "img/nf.5504f52b.svg";